import React, { useRef } from 'react';

import { APTooltipProvider, useTooltip } from 'components/Tooltip';

import './info-button.scss';

const InfoButton = (props) => {

  const { mode, tooltipProps, ...buttonProps } = props || {};
  const { message, tooltipDelay, floatingProps } = tooltipProps || {};

  if (mode === 'tooltip') {
    return (
      <APTooltipProvider
        tooltipDelay={tooltipDelay}
        floatingProps={floatingProps}
      >
        <TooltipButton
          {...buttonProps}
          message={message}
        />
      </APTooltipProvider>
    );
  }

  return (
    <i
      className="info-button"
      {...buttonProps}
    >
      i
    </i>
  );
};

const TooltipButton = ({ message, ...rest }) => {
  const ref = useRef();
  const { setCurrentTitle, setAnchor } = useTooltip();

  const onMouseEnter = () => {
    setCurrentTitle(message);
    setAnchor(ref.current);
  };

  const onMouseMove = () => {
    setCurrentTitle(message);
    setAnchor(ref.current);
  };

  const onMouseLeave = () => {
    setCurrentTitle(null);
    setAnchor(null);
  };
  return (
    <i
      ref={ref}
      className="info-button"
      {...rest}
      onMouseEnter={onMouseEnter}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      i
    </i>
  );
};

export default InfoButton;
